import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
import "../../helpers/font-awesome";
import { useGlobalData } from "../../context/globalDataContxt";
import NoteCard from "../NoteCard/NoteCard";
import "./NotesList.scss";

const NotesList = ({ notes, title, latest }) => {
  const notesLimit = 6;

  const { notesAll } = useGlobalData();

  const notesArray = latest
    ? notesAll.slice(0, notesLimit)
    : notes.map((note) => {
        return { ...note.note, id: note.id, noteName: note.noteName };
      });

  return notesArray && notesArray.length ? (
    <div className="mb-1 container">
      {/* Title */}
      <div className="mb-3 novelties-title-container">
        <div className={`mb-0 novelties-title`}>
          <FontAwesomeIcon icon={faNewspaper} className="me-2" />
          {title ? title : "NOTAS"}
        </div>

        <Link
          to={"/notas"}
          className={`cards-section-button rounded-pill px-3`}
        >
          Ver todas
        </Link>
      </div>

      {/* Preview de las Notas */}
      <div className="row novelty-container">
        {notesArray?.map((note, i) => {
          return (
            <div
              className={`col-12 col-md-6 col-lg-4`}
              key={`noteNodesId-${note.id}`}
            >
              <NoteCard key={note.id} note={note} />
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default NotesList;

NotesList.propTypes = {
  notes: PropTypes.array.isRequired,
  title: PropTypes.string,
  latest: PropTypes.bool,
};
